<template>
    <div>
        <p>我是专家主页界面</p>
    </div>
</template>

<script>
    export default {
        name: "expertHome"
    }
</script>

<style scoped>

</style>
